import { FlexContainer, Text } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const MailBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.blue_2};
  padding: ${pxToRem(20)} ${pxToRem(15)};
  border-radius: 8px;
  margin-bottom: ${pxToRem(30)};
  word-wrap: break-word;
`;

export const StyledImage = styled.div`
  display: flex;
  justify-content: center;
  max-width: ${pxToRem(150)};
  height: ${pxToRem(53)};
  img {
    width: 100%;
  }
`;

export const Span = styled.span`
  font-weight: bold;
`;

export const Img = styled.img`
  width: 100px;
  height: 100px;
`;

export const QuestionContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => `0 ${reference.dimension_16}`};
`;

export const EmailContainer = styled(Text)`
  word-break: break-all;
  padding: 0 28px;
`;
